export const extraHeaders: Record<string, string> = {};
